import { useState, useRef } from 'react';
import axios from 'Axios';
import { FileText, X } from 'tabler-icons-react';
import { clx, fileType, api, toastify, isObjEmpty } from 'Utils';
import { AddStoryBox, Button, FieldMessage } from 'Elements';
import styles from 'partials/dashboard/user-form.module.scss';

export const AddStoryMedia = ({ onAdd, onRemove, storyId, ...props }) => {
	const fileInput = useRef(null);
	const [state, setState] = useState({
		fields: {
			desciption: '',
			title: ''
		},
		disabled: false,
		fileUploaded: {},
		errors: {}
	});

	const handleInput = (e) => {
		const target = e.target;
		const fields = state.fields;
		fields[target.name] = target.value;
		setState((prev) => ({
			...prev,
			fields
		}));
	};

	const clearSelected = () => {
		fileInput.current.value = null;
		setState((prev) => ({
			...prev,
			fileUploaded: {}
		}));
	};

	const handleUpload = () => {
		fileInput.current.click();
	};

	const handleChange = (e) => {
		const fileUploaded = e.target.files[0];
		setState((prev) => ({
			...prev,
			fileUploaded
		}));
	};

	const validateForm = () => {
		let errors = {};
		const fields = state.fields;
		let formIsValid = true;
		if (!fields.title) {
			formIsValid = false;
			errors['title'] = 'عنوان محتوا را وارد کنید';
		}
		if (isObjEmpty(state.fileUploaded)) {
			formIsValid = false;
			errors['file'] = `فایل ${
				fileType[props.type].title
			} را انتخاب کنید`;
		}

		setState((prev) => ({
			...prev,
			errors
		}));
		return formIsValid;
	};

	const submitForm = () => {
		const data = {
			story_id: storyId,
			content_type: 'file',
			title: state.fields.title,
			description: state.fields.description,
			file_type: props.type,
			file: state.fileUploaded
		};

		const formData = new FormData();
		for (const field in data) {
			formData.append(field, data[field] ?? '');
		}

		if (validateForm()) {
			setState((prev) => ({
				...prev,
				disabled: true
			}));
			axios.post(api.storeStory, formData).then((res) => {
				const data = res.data;
				if (data.success) {
					setState((prev) => ({
						...prev,
						disabled: false
					}));
					toastify(
						<>
							<p>{`ثبت ${
								fileType[props.type].title
							} با موفقیت انچام شد`}</p>
							<p>
								{`${fileType[props.type].title} شما بعد از تایید
							ناظر در سایت منتشر می شود`}
							</p>
						</>,
						'success'
					);
				}
			});
		}
	};

	const handleSubmit = (e) => {
		submitForm();
		e.preventDefault();
	};

	return (
		<AddStoryBox
			type={props.type}
			icon={FileText}
			index={props.index}
			disabledSubmit={state.disabled}
			onAdd={onAdd}
			onSubmit={handleSubmit}
			onRemove={onRemove}>
			<div className="row">
				<div className="col-sm-6 mb-xxs-15">
					<div className={styles.field}>
						<label htmlFor={`title_${props.index}`} className={styles.label}>
							عنوان
						</label>
						<input
							type="text"
							id={`title_${props.index}`}
							name="title"
							className={styles.input}
							onChange={handleInput}
						/>
						{state.errors.title && (
							<FieldMessage text={state.errors.title} />
						)}
					</div>
				</div>
				<div className="col-sm-6 mb-xxs-15">
					<div className={styles.field}>
						<label htmlFor className={styles.label}>
							انتخاب فایل
						</label>
						<div className={styles.fieldGroup}>
							<Button
								className={styles.button}
								onClick={handleUpload}>
								{`انتخاب فایل ${fileType[props.type].title}`}
							</Button>
							<div className={styles.fieldRow}>
								<input
									hidden
									ref={fileInput}
									type="file"
									multiple={false}
									accept={fileType[props.type].accept}
									style={{ display: 'none' }}
									onChange={handleChange}
								/>
								{state.fileUploaded?.name && (
									<div
										className={[
											styles.fieldBox,
											styles.input_ltr
										].join(' ')}>
										<span
											className={[
												styles.text,
												styles.ellipsis
											].join(' ')}>
											{state.fileUploaded.name}
										</span>
										<Button
											title="حذف فایل"
											className={styles.removeSelected}
											onClick={clearSelected}>
											<X size="14" />
										</Button>
									</div>
								)}
							</div>
						</div>
						{state.errors.file && (
							<FieldMessage text={state.errors.file} />
						)}
					</div>
				</div>
				<div className="col-sm-12 mt-15">
					<div className={styles.field}>
						<label htmlFor={`desciption_${props.index}`} className={styles.label}>
							توضیحات
						</label>
						<textarea
							id={`desciption_${props.index}`}
							name="desciption"
							className={clx(styles.input, styles.textarea)}
							cols="10"
							rows="5"
							placeholder={`اگر ${
								fileType[props.type].title
							} دارای توضیحات خاصی می باشد در این بخش درج نمایید`}
							onChange={handleInput}
						/>
					</div>
				</div>
			</div>
		</AddStoryBox>
	);
};
